"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vatValid = void 0;
const vatValid = (vat) => {
    if (typeof vat === 'string' || typeof vat === 'number') {
        return String(vat).length >= 4 && String(vat).length <= 15;
    }
    return false;
};
exports.vatValid = vatValid;
